import { render, staticRenderFns } from "./InstructionModal.vue?vue&type=template&id=1c2886a6&scoped=true&"
import script from "./InstructionModal.vue?vue&type=script&lang=js&"
export * from "./InstructionModal.vue?vue&type=script&lang=js&"
import style0 from "./InstructionModal.vue?vue&type=style&index=0&id=1c2886a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2886a6",
  null
  
)

export default component.exports